import React from 'react';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { InputText, SelectCustom } from '@/components';
import PaymentType from '@/model/PaymentType';
import { FormInputName } from '../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const CreateFractionalPaymentContent: React.FC<Props> = ({
  formData,
  onChangeFormInput,
  formErrors,
}): JSX.Element => {
  const paymentTypeOptions = [
    {
      label: 'Dinheiro',
      value: `${PaymentType.MONEY}`,
    },
    {
      label: 'Cheque',
      value: `${PaymentType.CHECK}`,
    },
  ];
  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <h5 className="mb-5 border-bottom-title">{`${formData[FormInputName.ticket]} - ${
        formData[FormInputName.label]
      }`}</h5>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <InputText
              name="value"
              label="Valor"
              placeholder="Digite o valor"
              value={formData[FormInputName.value]}
              onChange={e => onChangeFormInput(FormInputName.value)(e.target.value)}
              error={formErrors.value && formErrors.value[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="paymentType"
              label="Forma de Pagamento"
              placeholder="..."
              value={formData[FormInputName.paymentType]}
              onChange={e => onChangeFormInput(FormInputName.paymentType)(e?.value as string)}
              error={formErrors.paymentType && formErrors.paymentType[0]}
              options={paymentTypeOptions}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
